import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import { Button, Box, IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { Modal } from 'antd-mobile'
import { components } from 'react-select'

import warningIcon from 'assets/icons/warning.svg'
import MyLocationIcon from 'assets/icons/precision.svg'
import * as userActions from 'actions/components/user'
import * as directoryActions from 'actions/components/directory'
import * as formActions from 'actions/components/form'
import { Merchant } from 'models/merchant'
import CircularDatePicker from '../DatePicker/CircularDatePicker'
import CircularDatePickerENG from '../DatePicker/CircularDatePickerENG'
import TimeslotSelector from '../Selector/TimeslotSelector'
import DraggableDialog from './DraggableDialog'
import { redirect } from 'helpers/redirect'
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete'
import helpers from 'helpers'
import * as appConstants from 'constants/app'
import * as merchantConstants from 'constants/merchant'

import { findPlacesByLatLng } from 'helpers/googleMap'
import URLParser from 'helpers/urlParser'
import { gtag } from 'helpers/gtag'

class StoreDelivery extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      address: props.user.address || '',
      floorRoom: props.user.floorRoom || '',
      companyBuilding: props.user.companyBuilding || '',
      lat: props.user.lat || 0,
      lng: props.user.lng || 0,
      shipping: {},
      deliveryTime: this.calculateDeliveryTime(),
    }
    this.availableTimeslots = []
    this.availableDates = []
    this.minDate = null
    this.maxDate = null
  }

  componentDidMount = () => { }

  componentDidUpdate = (prevProps, prevState) => {
    const { merchant } = this.props
    const isOpen = this.props.directory.display.storeDelivery

    // 當打開 StoreDelivery Dialog 時
    if (!prevProps.directory.display.storeDelivery && this.props.directory.display.storeDelivery) {
      this.getStoreDeliveryTimeSlots(merchant)
      this.updateAvailableDates()
      this.updateTimeslots()
      this.handleAddressSelected()
    }

    if (isOpen) {
    // 當運送時間變的時候重新拿 timeslots 並更新預設選擇的時段
      if (prevState.deliveryTime !== this.state.deliveryTime) {
        this.getStoreDeliveryTimeSlots(merchant)
        if (!this.availableTimeslots.length) {
          this.updateAvailableDates()
        }
        this.updateTimeslots()
      }

      // Update storeDelivery timeslots when the selectedDate is changed.
      if (prevProps.directory.selectedDate !== this.props.directory.selectedDate) {
        this.getStoreDeliveryTimeSlots(merchant)
        if (!this.availableTimeslots.length) {
          this.updateAvailableDates()
        }
        this.updateTimeslots()
      }

      //  如果沒有找到可用的 shipping 顯示 dialog
      if (typeof prevState.shipping === 'object' && !this.state.shipping) {
        this.renderNoAvailableShippingAlert()
      }

      // geoQuery
      if (prevState.address !== this.state.address) {
        this.handleAddressSelected()
      }
    }
  }

  getStoreDeliveryTimeSlots = (merchant) => {
    if (!merchant) return
    const { deliveryTime } = this.state
    const m = new Merchant(merchant)
    const availables = _(m.getFutureStoreDeliveryTimeslots(deliveryTime)).groupBy(timeslot => timeslot.format('YYYY-MM-DD')).value()
    this.availableDates = Object.keys(availables)
    this.availableTimeslots = availables[moment(this.props.directory.selectedDate).format('YYYY-MM-DD')] || []
  }

  updateAvailableDates = () => {
    const keys = Object.keys(this.availableDates)
    this.minDate = this.availableDates[keys[0]]
    this.maxDate = this.availableDates[keys[keys.length - 1]]
    if (this.props.directory.selectedDate !== this.minDate) {
      this.props.updateSelectedDate(this.minDate)
    }
  }

  updateTimeslots = () => {
    const defaultTimeslot = (this.availableTimeslots && this.availableTimeslots.length > 0) && this.availableTimeslots[0].toISOString()
    if (this.props.directory.selectedTime !== defaultTimeslot) {
      this.props.updateSelectedTime(defaultTimeslot)
    }
  }

  getCurrentAddress = async () => {
    const successCallback = async (position) => {
      try {
        const latLng = { lat: position.coords.latitude, lng: position.coords.longitude }
        // const latLng = { lat: 22.27662472534866, lng: 114.15275073462647 } // test
        const request = { location: latLng }
        const places = await findPlacesByLatLng(request)

        if (_.isEmpty(places)) {
          this.setState({ address: '' })
        } else {
          this.setState({ address: places[0].formatted_address })
        }
        this.props.updateDisplayBackdropLoading(false)
      } catch (error) {
        console.log('findPlacesByLatLng error', error)
        this.props.updateDisplayBackdropLoading(false)
      }
    }

    const errorCallback = (positionError) => {
      console.log(positionError)
      this.props.updateDisplayBackdropLoading(false)
      this.rendeGetCurrentPositionTimoutAlert()
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10 * 1000,
      maximumAge: 60 * 1000,
    }

    this.props.updateDisplayBackdropLoading(true)
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options)
  }

  calculateDeliveryTime=(duration) => {
    const { merchant } = this.props
    const shippings = _.filter(merchant.shippings, s => s.type === 'storeDelivery' && s.enabled)
    const shipping = _.clone(shippings[0])
    const preparingTime = shipping ? shipping.minDeliveryMinute : 0 // 備餐時間
    const shippingTime = duration ? Math.ceil(duration.value / 60) : 15 // 路程
    const bufferTime = appConstants.LALAMOVE_BUFFER // 15分鐘緩衝
    const deliveryTime = preparingTime + shippingTime + bufferTime
    return deliveryTime
  }

  handleAddressSelected = async (e, options) => {
    const { merchant } = this.props

    if (!window.google) {
      setTimeout(() => this.handleAddressSelected(e, options), 1000)
      return
    }
    this.props.updateDisplayBackdropLoading(true)

    const address = e ? e.value.description : this.state.address

    if (address) {
      try {
        const geocodeResult = await geocodeByAddress(address)
        const destination = await getLatLng(geocodeResult[0])
        const origin = await helpers.googleMap.getOriginLatLng({ location: merchant.setting.location, address: merchant.address })
        console.log('geocodeByAddress', { geocodeResult, origin, destination })

        const directionResult = await helpers.googleMap.getDirectionResult({ origin, destination })
        const duration = directionResult.routes[0].legs[0].duration // e.g. { text: "14 分鐘", value: 827 }
        console.log('getDirectionResult', { directionResult, duration })

        const shippings = _.filter(merchant.shippings, s => s.type === 'storeDelivery' && s.enabled)
        const shipping = _.clone(shippings[0])

        const deliveryTime = this.calculateDeliveryTime(duration)
        if (deliveryTime !== this.state.deliveryTime) {
          this.setState({ deliveryTime })
        }

        this.setState({
          ...destination, // lat lang
          address,
          shipping,
          duration,
        })
      } catch (error) {
        this.props.updateDisplayBackdropLoading(false)
        this.renderNoAvailableShippingAlert()
      }
    }

    this.props.updateDisplayBackdropLoading(false)
  }

  handleSubmit = async () => {
    const { directory, merchant, query } = this.props
    const { address, floorRoom, companyBuilding, lat, lng, deliveryTime } = this.state
    const date = moment(directory.selectedDate).format('YYYY-MM-DD')
    const time = moment(directory.selectedTime).format('HH:mm')
    let datetime = moment(`${date} ${time}`)
    const immediate = moment().add(deliveryTime, 'minutes')
    const isOverTime = datetime.isSameOrBefore(immediate)
    const urlParser = new URLParser()

    if (isOverTime) {
      datetime = immediate
    }
    datetime = datetime.toISOString()
    this.props.setForm({ datetime })

    // Update user
    this.props.updateAddress(address)
    this.props.updateFloorRoom(floorRoom)
    this.props.updateCompanyBuilding(companyBuilding)
    this.props.updateLat(lat)
    this.props.updateLng(lng)

    gtag('event', 'datepicker submit', {
      event_label: 'datepicker submit',
      event_category: 'datepicker submit',
      value: 1,
    })

    // Redirect to restaurant.
    redirect('sdelivery', merchant, query, {
      datetime,
      address,
      ...!!urlParser.getQuery('ref') && { ref: urlParser.getQuery('ref') },
    })
  }

  renderOpeningInfo = () => {
    const { intl, classes, merchant } = this.props
    if (!merchant) return null

    const openingTitleText = intl.formatMessage({ id: 'directory.opening.subtitle.delivery' })
    const openings = merchant.setting.directoryDeliveryTimeText || merchant.setting.directoryOpeningTimeText

    return (
      <div className={classes.info}>
        <div className={classes.icon}>
          <img src={warningIcon} alt='warning_icon' />
        </div>
        <div className={classes.textContent}>
          <p>{
            merchant.setting.defaultClientLanguage === 'en'
            ? 'Delivery'
            : openingTitleText
          }</p>
          <p className={classes.openings}>{openings}</p>
        </div>
      </div>
    )
  }

  renderNoAvailableShippingAlert = () => {
    const { intl } = this.props
    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
    const titleText = intl.formatMessage({ id: 'dialog.no_available_shipping.title' })
    const message = merchant.setting.defaultClientLanguage === 'en' ? 'Please enable location service on your device, or enter your address directly' : intl.formatMessage({ id: 'dialog.no_available_shipping.message' })
    const title = (<p style={{ lineHeight: 1.5, margin: 0 }}>{
      merchant.setting.defaultClientLanguage === 'en'
      ? 'Cannot locate your current position'
      : titleText
    }</p>)
    const goBackButton = {
      text: 
        merchant.setting.defaultClientLanguage === 'en'
        ? 'Cancel'
        : goBackButtonText
      ,
      onPress: () => this.setState({ shipping: {} }),
    }
    const buttons = [goBackButton]
    Modal.alert(title, message, buttons)
  }

  rendeGetCurrentPositionTimoutAlert = () => {
    const { intl } = this.props
    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
    const titleText = intl.formatMessage({ id: 'dialog.no_current_location.title' })
    const message = merchant.setting.defaultClientLanguage === 'en' ? 'Please enable location service on your device, or enter your address directly' : intl.formatMessage({ id: 'dialog.no_available_shipping.message' })
    const title = (<p style={{ lineHeight: 1.5, margin: 0 }}>{
      merchant.setting.defaultClientLanguage === 'en'
      ? 'Cannot locate your current position'
      : titleText
    }</p>)
    const goBackButton = {
      text: merchant.setting.defaultClientLanguage === 'en'
      ? 'Cancel'
      : goBackButtonText,
      onPress: () => {},
    }
    const buttons = [goBackButton]
    Modal.alert(title, message, buttons)
  }

  // 用空白的 div 取代 react select 的 dropdown indicator
  // 之後用 absolute 把定位 icon button 蓋上去
  DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <div style={{ width: 16, height: 16 }} />
      </components.DropdownIndicator>
    )
  }

  render () {
    const { intl, classes, merchant, directory } = this.props
    const { address, shipping, deliveryTime } = this.state

    if (!merchant) return null

    const { storeDelivery } = directory.display
    const handleClose = () => this.props.updateDisplay('storeDelivery', false)

    const dialogTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Please Select Your Time' : intl.formatMessage({ id: 'directory.dateTimePicker.title.delivery' })
    const datePickerTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Select A Date' : intl.formatMessage({ id: 'directory.dateTimePicker.selectDate.delivery' })
    const timePickerTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Select A Time (Delivery time may vary depending on traffic and distance*)' : intl.formatMessage({ id: 'directory.dateTimePicker.selectTime.delivery' })
    const addressText = merchant.setting.defaultClientLanguage === 'en' ? 'Address' : intl.formatMessage({ id: 'summary.restaurant.info.address' })
    const addressPlaceholderText = merchant.setting.defaultClientLanguage === 'en' ? 'Please fill in your address' : intl.formatMessage({ id: 'shipping.please_fill_address' })
    const noOptionsMessageText = merchant.setting.defaultClientLanguage === 'en' ? 'No Options' : intl.formatMessage({ id: 'shipping.no_options_message' })
    const loadingMessageText = merchant.setting.defaultClientLanguage === 'en' ? 'Loading' : intl.formatMessage({ id: 'loading' })
    const submitText = merchant.setting.defaultClientLanguage === 'en' ? 'Make Your Order' : intl.formatMessage({ id: 'directory.dateTimePicker.submit' })
    const handleDateChange = (date) => {
      this.props.updateSelectedDate(date)
    }

    return (
      <DraggableDialog
        open={storeDelivery}
        onClose={handleClose}
      >
        <React.Fragment>
          <p className={classes.title}>{dialogTitleText}</p>
          {this.renderOpeningInfo()}

          <section className={classes.section}>
            <p>{datePickerTitleText}</p>
            {
            merchant.setting.defaultClientLanguage === 'en' 
            ? <CircularDatePickerENG
              dates={this.availableDates}
              handleDateChange={handleDateChange}
            />
            : <CircularDatePicker
              dates={this.availableDates}
              handleDateChange={handleDateChange}
            />
          }
          </section>

          <section className={classes.section}>
            <p className={classes.pb8}>{addressText}</p>

            <div className={classes.relative}>
              <GooglePlacesAutocomplete
                key={address} // address 變的時候 rerender GooglePlacesAutocomplete
                debounce={300}
                selectProps={{
                  components: {
                    DropdownIndicator: this.DropdownIndicator,
                    IndicatorSeparator: () => null,
                  },
                  placeholder: `${addressPlaceholderText}...`,
                  onChange: this.handleAddressSelected,
                  defaultInputValue: address,
                  loadingMessage: () => {
                    return <span>{loadingMessageText}</span>
                  },
                  noOptionsMessage: () => {
                    if (!address || this.state.address) {
                      return null
                    }
                    return <span>{noOptionsMessageText}</span>
                  },
                }}
                autocompletionRequest={{
                  componentRestrictions: {
                    country: ['hk'],
                  },
                }}
              />

              <IconButton className={classes.myLocationButton} onClick={this.getCurrentAddress} >
                <img className={classes.myLocationIcon} src={MyLocationIcon} alt="MyLocationIcon"/>
              </IconButton>
            </div>

          </section>

          <section className={classes.section}>
            <p>{timePickerTitleText}</p>
            <TimeslotSelector
              deliveryType={merchantConstants.DELIVERY_TYPE_STOREDELIVERY}
              timeslots={this.availableTimeslots}
              deliveryTime={deliveryTime}
            />
          </section>

          <Box display='flex' justifyContent='center' alignItems='center' mt='24px' mb='24px'>
            <Button
              disableElevation
              className={classes.submitButton}
              color='primary'
              variant='contained'
              disabled={_.isEmpty(shipping)}
              onClick={this.handleSubmit}
            >
              {submitText}
            </Button>
          </Box>
        </React.Fragment>
      </DraggableDialog>
    )
  }
}

const styles = {
  title: {
    margin: 0,
    padding: '8px 24px 8px 24px',
    fontWeight: 500,
    fontSize: 22,
  },
  info: {
    display: 'flex',
    '& p': {
      margin: 0, // remove default margin
      fontSize: 15,
      fontFamily: 'Roboto',
      lineHeight: '21px', // the height of the icon.
      color: '#95292C',
    },
  },
  icon: {
    height: 21,
    width: 21,
    display: 'grid',
    placeItems: 'center',
    marginRight: 8,
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    gridGap: '4px',
    '& > p': {
      whiteSpace: 'pre',
    },
  },
  gridItemFullwidth: {
    gridColumn: '1 / span 3',
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  section: {
    marginTop: 24,
    '& > p': {
      margin: 0, // remove default margin
      fontSize: 16,
      color: '#8A8A8A',
    },
  },
  submitButton: {
    alignSelf: 'center',
    color: '#ffffff',
    width: 220,
    height: 40,
    fontSize: 18,
    fontWeight: 300,
    borderRadius: 10,
  },
  underline: {
    borderBottom: '2px solid #EBBD3F',
  },
  openings: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
  },
  input: {
    height: 16,
    width: 'calc(100% - 22px)',
    padding: '10px',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D8D8D8',
    borderRadius: 5,
  },
  pb8: {
    paddingBottom: 8,
  },
  relative: {
    position: 'relative',
  },
  myLocationButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  myLocationIcon: {
    width: 16,
    height: 16,
  },
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    query: state.query,
    user: state.user,
    merchant: state.merchant,
    directory: state.directory,
    form: state.form,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(userActions, dispatch),
  ...bindActionCreators(directoryActions, dispatch),
  ...bindActionCreators(formActions, dispatch),
})

export default withRouter(
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    injectIntl,
  )(StoreDelivery),
)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Dialog/StoreDelivery.jsx